export const API_KEY = "AIzaSyCNWLE4YM6ajxPiVruc18Sj_CE3Pzv7lx0";

export default API_KEY;
